export default "__VITE_ASSET__CuKZnugA__"